/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useRoutes } from "react-router-dom";
import { MinimalLayout } from "../layout/MinimalLayout";
import React from "react";
import { Welcome } from "./index";
// import Error from './Error'

const WelcomeRoutes = () => {
    
    return useRoutes([
        {
            path: "Welcome",
            element: <MinimalLayout />,
            children: [
                {
                    index: true,
                    element: <Welcome />,
                },
                // {
                //     path: 'login',
                //     element: <Welcome />,
                // },
                // {
                //     path: 'logout',
                //     element: <Welcome />,
                // },
                // {
                //     path: 'Error',
                //     element: <Error />,
                // },
            ],
        },
    ]);
    
};
export { WelcomeRoutes };
